import Select, { SelectOption } from '@anm/components/select/Select';
import { useCallback, useState, FC } from 'react';
import { useSelector } from 'react-redux';

import { hostedVideoSelectors } from '../../../../store/modules/hostedVideo';
import { userSelectors } from '../../../../store/modules/user';
import { DOWNLOAD_BUTTON_LABEL } from '../../../hosting/CustomizationSection';
import { SelectContainer } from '../Wrapper';

import { ButtonProps } from '.';

type ComponentProps = Omit<ButtonProps, 'onActiveButtonChange'>;

const DropdownButtons: FC<ComponentProps> = ({ list, activeButton, onActionSheetOpen }) => {
  const isUserFree = useSelector(userSelectors.selectIsUserFree);
  const videoData = useSelector(hostedVideoSelectors.selectVideoData);

  const buttons = list.map(item => item.button);

  const options = list.map((item, i) => ({
    value: i,
    label: item.button.title,
    icon: item.button.icon,
    isAutoClose: item.button.title !== DOWNLOAD_BUTTON_LABEL,
    renderTooltip: item.button.renderTooltip
  }));

  const [currentOption, setCurrentOption] = useState<SelectOption<number>>(options[activeButton]);

  const handleChange = useCallback(
    (option: SelectOption<number>) => {
      const isDownloadButton = option.label === DOWNLOAD_BUTTON_LABEL;
      if (isDownloadButton && videoData?.sources.length) {
        onActionSheetOpen?.();
        return;
      }

      setCurrentOption(option);
      const currentButton = buttons[option.value as number];
      currentButton.onClick?.();
    },
    [list]
  );

  return (
    <SelectContainer {...{ isUserFree }}>
      <Select name="mobile-buttons" value={currentOption} onChange={handleChange} {...{ options }} />
    </SelectContainer>
  );
};

export default DropdownButtons;
